const escapePointer = (s)=>s.replace(/~/g, '~0').replace(/\//g, '~1');
/** Mirrors PRP-13's server allowlist. Rates intentionally have no patch path. */ export function pricingPathAllowed(path) {
    const t = path.slice(1).split('/').map((s)=>s.replace(/~1/g, '/').replace(/~0/g, '~'));
    if (!path.startsWith('/') || t.some((s)=>!s || [
            '__proto__',
            'prototype',
            'constructor'
        ].includes(s))) return false;
    if ([
        'scenarioName',
        'contractType'
    ].includes(t[0])) return t.length === 1;
    if ([
        'sharedTierConfigs',
        'globalFeeMethod',
        'globalIndirectConfig'
    ].includes(t[0])) return true;
    if (t[0] === 'rateCard') return t.length === 2 && t[1] === 'rateType' || t[1] === 'escalation' && (t.length === 3 && t[2] === 'defaultPct' || t.length === 4 && t[2] === 'perPeriodOverrides');
    if (t[0] !== 'clinPricing' || !/^\d+$/.test(t[1]) || t.length < 3) return false;
    if (t.length === 6 && t[2] === 'metadata' && t[3] === 'travelConfig' && t[4] === 'handlingRatePct' && t[5] === 'value') return true;
    return [
        'rateMethod',
        'feeMethod',
        'aggregation',
        'volumeMethod',
        'columns',
        'lines'
    ].includes(t.at(-1) || '') || t.at(-1) === 'value' && t.at(-3) === 'parameters' || t.at(-2) === 'periodValues' || t.at(-2) === 'lines';
}
/** Use leaf ops where allowed; structural changes use the nearest allowed container. */ export function pricingDiff(before, after, path = '') {
    if (JSON.stringify(before) === JSON.stringify(after)) return [];
    const container = before !== null && after !== null && typeof before === 'object' && typeof after === 'object';
    if (container && (!Array.isArray(before) || Array.isArray(after) && before.length === after.length)) {
        const a = before;
        const b = after;
        try {
            return [
                ...new Set([
                    ...Object.keys(a),
                    ...Object.keys(b)
                ])
            ].flatMap((key)=>pricingDiff(a[key], b[key], `${path}/${escapePointer(key)}`));
        } catch (error) {
            if (!pricingPathAllowed(path)) throw error;
        }
    }
    if (!pricingPathAllowed(path)) throw new Error(`This field can't be changed here: ${path}`);
    return [
        {
            op: after === undefined ? 'remove' : 'set',
            path,
            valueJson: after === undefined ? '' : JSON.stringify(after)
        }
    ];
}
export function applyPricingOps(pricing, ops) {
    const draft = structuredClone(pricing);
    for (const op of ops){
        const tokens = op.path.slice(1).split('/').map((s)=>s.replace(/~1/g, '/').replace(/~0/g, '~'));
        let node = draft;
        for (const token of tokens.slice(0, -1)){
            var _node, _token;
            (_node = node)[_token = token] ?? (_node[_token] = {});
            node = node[token];
        }
        const leaf = tokens.at(-1);
        if (op.op === 'remove') delete node[leaf];
        else node[leaf] = JSON.parse(op.valueJson);
    }
    return draft;
}
